import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { OrganizationReportEditDialogHeader } from "./OrganizationReportEditDialogHeader";
import { OrganizationReportEditForm } from "./OrganizationReportEditForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/organizationReportAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { INIT_ORGANIZATION_REPORT } from "../OrganizationReportUIHelpers";
import LoadingAnimation from "../../../../config/loading-animation/LoadingAnimation";

export const OrganizationReportEditDialog = ({
  match: {
    params: { id }
  },
  history
}) => {
  const [queryParams, setQueryParams] = useState({
    pageNumber: 1,
    pageSize: 10,
    filter: {}
  });

  const [initialValues, setInitialValues] = useState(INIT_ORGANIZATION_REPORT);

  // OrganizationReport Redux state
  const dispatch = useDispatch();
  const {
    actionsLoading,
    organizationReportForEdit,
    error,
    organization
  } = useSelector(
    state => ({
      actionsLoading: state.organizationReports.actionsLoading,
      organizationReportForEdit:
        state.organizationReports.organizationReportForEdit,
      error: state.organizationReports.error,
      organization: state.auth.user.organization
    }),
    shallowEqual
  );
  if (error) {
    toast.error(error, toastOption);
  }

  useEffect(() => {
    // server call for getting OrganizationReport by id
    dispatch(actions.fetchOrganizationReport(id));
  }, [id, dispatch]);

  useEffect(() => {
    setInitialValues(prev => {
      if (id) {
        return {
          ...prev,
          ...organizationReportForEdit
        };
      } else {
        return {
          ...INIT_ORGANIZATION_REPORT,
          bank_name: organization.bank_name ?? "",
          bank_account: organization.bank_account ?? "",
          bank_account_behalf: organization.bank_account_behalf ?? ""
        };
      }
    });
  }, [organizationReportForEdit]);

  const saveOrganizationReport = async values => {
    const formData = new FormData();

    Object.keys(values).map(key => {
      formData.append(key, values[key]);
    });

    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + "=> " + pair[1]);
    // }

    try {
      if (!id) {
        const res = await dispatch(actions.createOrganizationReport(formData));
        
        if (res.data) {
          toast.success(res.message, toastOption);
          dispatch(actions.fetchOrganizationReports(queryParams)).then(() =>
            history.push("/organization-report")
          );

          return;
        }
      
        toast.err("Create Data Unsuccesfully", toastOption);
      } else {
        const res = dispatch(actions.updateOrganizationReport(formData))
        
        if (res.data) {
          toast.success(res.message, toastOption);
          dispatch(actions.fetchOrganizationReports(queryParams)).then(() =>
            history.push("/organization-report")
          );
        }
      }
    } catch (err) {
      toast.err("Create Data Unsuccesfully", toastOption);
    }
    
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      <OrganizationReportEditForm
        id={id}
        history={history}
        saveOrganizationReport={saveOrganizationReport}
        actionsLoading={actionsLoading}
        organizationReport={
          initialValues || {
            bank_name: "",
            bank_accountL: "",
            bank_account_behalf: ""
          }
        }
      />
    </>
  );
};
